import { ScheduledSms } from '@weave/schema-gen-ts/dist/schemas/messaging/scheduled/shared/v1/models.pb';
import { OutboundMessageStatus, ThreadType } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { genUUIDV4 } from '@frontend/string';
import { ScheduleGroupSMSIO, ScheduleIO } from '../types';

export const convertScheduleRequestToScheduledSms = (
  {
    locationPhone = '',
    personId = '',
    mediaIds = [],
    relatedIds = [],
    pausable = false,
    departmentId = '',
    ...request
  }: ScheduleIO['input'],
  otherValues?: Partial<Omit<ScheduledSms, keyof ScheduleIO['input']>>
): ScheduledSms => ({
  ...request,
  ...otherValues,
  id: otherValues?.id || genUUIDV4(),
  personId,
  locationPhone,
  departmentId,
  mediaIds,
  status: otherValues?.status ?? OutboundMessageStatus.UNSPECIFIED,
  statusDetails: otherValues?.statusDetails ?? '',
  sentAt: otherValues?.sentAt ?? '',
  scheduledAt: otherValues?.scheduledAt ?? '',
  deletedAt: otherValues?.deletedAt ?? '',
  deletedBy: otherValues?.deletedBy ?? '',
  updatedAt: otherValues?.updatedAt ?? '',
  relatedIds,
  pausable,
});

export const convertScheduleGroupSMSRequestToScheduledSms = (
  {
    body = '',
    mediaIds = [],
    relatedIds = [],
    recipients = [],
    pausable = false,
    ...request
  }: ScheduleGroupSMSIO['input'],
  otherValues?: Partial<Omit<ScheduledSms, keyof ScheduleGroupSMSIO['input']>>
): ScheduledSms => ({
  ...request,
  ...otherValues,
  id: otherValues?.id || genUUIDV4(),
  personId: otherValues?.personId ?? '',
  departmentId: otherValues?.departmentId ?? '',
  personPhone: recipients[0]?.personPhone ?? '',
  body,
  mediaIds,
  status: otherValues?.status ?? OutboundMessageStatus.UNSPECIFIED,
  statusDetails: otherValues?.statusDetails ?? '',
  sentAt: otherValues?.sentAt ?? '',
  scheduledAt: otherValues?.scheduledAt ?? '',
  deletedAt: otherValues?.deletedAt ?? '',
  deletedBy: otherValues?.deletedBy ?? '',
  updatedAt: otherValues?.updatedAt ?? '',
  relatedIds,
  pausable,
  threadType: ThreadType.THREAD_TYPE_GROUP_MMS,
});
